import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    id: string
    eyebrow: string
    title: ReactNode
    description?: ReactNode
    align?: 'left' | 'center'
    tone?: 'dark' | 'light'
    className?: string
}

const SectionHeading: FC<SectionHeadingProps> = ({
    id,
    eyebrow,
    title,
    description,
    align = 'left',
    tone = 'dark',
    className
}): ReactNode => {
    const light = tone === 'light'

    return (
        <div className={cn('max-w-2xl', align === 'center' && 'mx-auto text-center', className)}>
            <p className={cn('text-xs font-bold uppercase tracking-[0.16em]', light ? 'text-brand-300' : 'text-brand-600')}>
                {eyebrow}
            </p>

            <h2
                id={id}
                className={cn(
                    'mt-3 font-heading text-3xl font-bold tracking-[-0.025em] text-balance sm:text-4xl lg:text-[2.75rem] lg:leading-[1.1]',
                    light ? 'text-white' : 'text-foreground'
                )}
            >
                {title}
            </h2>

            {description && (
                <p className={cn('mt-4 text-base leading-relaxed text-pretty sm:text-lg', light ? 'text-white/75' : 'text-muted-foreground')}>
                    {description}
                </p>
            )}
        </div>
    )
}

export default SectionHeading
